export default __webpack_public_path__ + "static/media/gift.55d5a2aa.png";